<template>
  <div class="site-tab">
    <template v-for="(item, index) in menus">
      <!--  v-if="user.codeList&&user.codeList.includes(item.code)" -->
      <div :class="['site-tab__item ipubw-p1', path.includes(item.href)?'active':'']"
           v-if="item.code && user.codeList&&user.codeList.includes(item.code)"
           :key="'site-tab-menus'+index">
        <router-link :to="item.href">{{item.name}}</router-link>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    menus: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      path: ''
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route () {
      this.path = this.$route.path
    },
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  mounted () {
    this.path = this.$route.path
  }
}
</script>

<style lang="scss" scoped>
.site-tab {
  display: flex;
  align-items: flex-end;
  padding-bottom: 4px;
  border-bottom: 1px solid $line_color;
  &__item {
    margin-right: 80px;
    position: relative;
    transition: 0.3s all;
    @media screen and (max-width: 1440px) {
      @include ipub-p1;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -5px;
      height: 2px;
      background: $link_color;
      width: 0;
      transition: 0.3s all;
    }
    &.active,
    &:hover {
      a {
        color: $link_color;
      }
      &::after {
        // width: 40px;
        width: 100%;
      }
    }
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
